/*
 * © 2021 Sukoa AG <Interactive Technologies> http://www.sukoa.com
 */

import DataLayerEvent from "../DataLayerEvent";

class ViewCartDL extends DataLayerEvent {
    constructor(item) {
        super();
        this.ecommerce = item;
    }

    generateParameters() {
        this.getParameters().event = 'view_cart';
        this.getParameters().ecommerce = this.ecommerce;
    }

}

export default ViewCartDL;
